import * as React from 'react';
import api from '../api/apiClient';
import { Button, ButtonToolbar, Form, Modal } from 'react-bootstrap';
import moment from 'moment';
import { useParams } from 'react-router-dom';



interface ImportCompetitorsParams {
	raceid: string
}

class ImportCompetitorsComponent extends React.Component<ImportCompetitorsParams, any> {

	constructor(props) {
		super(props);

		this.parse = this.parse.bind(this);
		this.sortRows = this.sortRows.bind(this);
		this.handlePaste = this.handlePaste.bind(this);
		this.handleFileSelect = this.handleFileSelect.bind(this);
	}

	componentDidMount() {
		var raceId = this.props.raceid;
		this.getRace(raceId)
	}

	handlePaste(event) {
		var pastedData = event.clipboardData.getData('text');
		if (pastedData) {
			this.setState({ importData: pastedData }, () => this.parse());
			event.preventDefault();
		}
	}

	handleFileSelect(event) {
		var file = event.target.files[0];
		if (!file) return;
		var reader = new FileReader();
		reader.onload = (e) => {
			this.setState({ importData: (e.target as FileReader).result as string }, () => this.parse());
		};
		reader.readAsText(file);
	}

	stringOrder = (a: string, b: string) => (a < b) ? -1 : (a > b) ? 1 : 0;

	seriesPoints = {};

	emptyGuid = '00000000-0000-0000-0000-000000000000';


	getRace(raceId) {
		api.request('races/' + raceId).then(data => {
			this.setState({
				race: data
			});

			this.getCompetitorsInSeries(data.seriesId);
			this.getClasses(data.seriesId);
		});
	}


	getClasses(seriesId) {
		api.request('SeriesClasses?seriesId=' + seriesId).then(data => {
			this.setState({
				classes: data
			});
		});
	}

	getCompetitorsInSeries(seriesId) {
		var competitorsPromise = api.request('competitors/inseries?seriesid=' + seriesId).then(data => {

			this.setState({
				competitorsByNumber: data.reduce((map, obj) => (map[obj.number] = obj, map), {}),
				competitors: data
			}, () => this.getCompetitorSeriesPoints(seriesId));
		});
	}

	//* Empty class id gives the overall standing (all competitors ranked together), not the class standing
	getSeriesPointsPromise(seriesId) {
		if (!this.seriesPoints[seriesId]) {
			var apiPromise = api.request('results/SeriesResult?seriesId=' + seriesId + '&classid=' + this.emptyGuid);

			var promise = apiPromise.then(data => {
				return data.reduce((map, obj) => (map[obj.competitorId] = obj.totalPoints, map), {});
			});
			this.seriesPoints[seriesId] = promise;
			return promise;
		}
		else {
			return this.seriesPoints[seriesId];
		}
	}

	getCompetitorSeriesPoints(seriesId) {


		this.getSeriesPointsPromise(seriesId).then(points => {

			var competitors = { ...this.state.competitorsByNumber };
			var numbers = Object.keys(competitors);

			numbers.forEach((number, index) => {
				if (points[competitors[number].id]) {
					competitors[number].points = points[competitors[number].id];
				}
			});

			this.setState({ competitorsByNumber: competitors });

		});
	}

	getExistingCompetitor(number) {
		var getExistingCompetitor = this.state.competitorsByNumber[number];
		if (getExistingCompetitor) return getExistingCompetitor;
		else return '';
	}



	/*
	getExistingCompetitorName(number) {
		var getExistingCompetitor = this.state.competitorsByNumber[number];
		if (getExistingCompetitor) return getExistingCompetitor.name;
		else return '';
	}
	*/


	state = {
		raceId: '',
		importData: '',
		rowFormat: '',
		rows: [],
		race: null,
		classes: [],
		competitors: [],
		competitorsByNumber: [],
		columnNames: [],
		classMap: {},
		columnMap: {
			name: 0,
			number: 6,
			//club: 2,
			phone: 5,
			ssn: 1,
			group: 3,
			transponder: 7
		}

	}

	mapClass(name, id) {
		var classMap = { ...this.state.classMap };
		classMap[name] = id;
		this.setState({ classMap: classMap });
	}

	generateTransponderNumbers() {

		var transponderNumber = 0;

		var rows = this.state.rows.map(row => {
			if (row.transponderGenerateStart) transponderNumber = row.transponderGenerateStart;
			if (transponderNumber) {
				row.transponder = transponderNumber;
				transponderNumber++;
			}
			else
			{
				row.transponder = null;
			}


			return row;
		})


		this.setState({ rows: rows });


	}

	setTransponder(rowNumber, transponderNumber) {
		var rows = [...this.state.rows];

		rows[rowNumber]['transponderGenerateStart'] = transponderNumber;
			
		this.setState({rows:rows}, () => {
			this.generateTransponderNumbers();
		});
		
	}

	setRemoveRow(index) {
		this.setState(state => {
			var rows = [...state.rows];
			rows.splice(index, 1);
			return { rows };
		});
	}

	async importAll() {
		for (var i = 0; i < this.state.rows.length; i++) {
			var rowStatus = this.state.rows[i].status;
			if (rowStatus != 'updated' && rowStatus != 'imported') {
				await this.importRow(i);
			}
		}
	}

	async importRow(index) {
		var row = { ...this.state.rows[index] };

		var classId = this.state.classMap[row.values[this.state.columnMap.group]];

		if (!classId) {
			row.status = 'Class is required';
			this.setState(state => { var rows = [...state.rows]; rows[index] = row; return { rows }; });
			return;
		}

		if (isNaN(parseInt(row.values[this.state.columnMap.number]))) {
			row.status = 'Number is required';
			this.setState(state => { var rows = [...state.rows]; rows[index] = row; return { rows }; });
			return;
		}

		if (classId == '+') {

			var seriesClass = {
				name: row.values[this.state.columnMap.group],
				seriesId: this.state.race.seriesId,
			}

			var newSeriesClass = await api.post('SeriesClasses/class', seriesClass);
			this.setState(state => ({ classes: [...state.classes, newSeriesClass] }));

			this.mapClass(row.values[this.state.columnMap.group], newSeriesClass.id);

			classId = newSeriesClass.id;
		}

		var competitor = {
			id:'00000000-0000-0000-0000-000000000000',
			name: row.values[this.state.columnMap.name],
			number: parseInt(row.values[this.state.columnMap.number]),
			phone: row.values[this.state.columnMap.phone],
			ssn: row.values[this.state.columnMap.ssn],
			age: this.getAge(row.values[this.state.columnMap.ssn]),
			transponder: (this.state.columnMap.transponder == 1337 && row.transponder) ? row.transponder.toString() : row.values[this.state.columnMap.transponder],
			raceId: this.state.race.id,
			seriesClassId: classId,
			dnf: false,
			seriesPoints: null
		}

		if (!competitor.name) {
			row.status = 'Name is required';
			this.setState(state => { var rows = [...state.rows]; rows[index] = row; return { rows }; });
			return;
		}

		if (isNaN(competitor.number)) {
			row.status = 'Number is required';
			this.setState(state => { var rows = [...state.rows]; rows[index] = row; return { rows }; });
			return;
		}

		if (!competitor.transponder) {
			row.status = 'Transponder is required';
			this.setState(state => { var rows = [...state.rows]; rows[index] = row; return { rows }; });
			return;
		}

		var existingCompetitor = this.getExistingCompetitor(row.values[this.state.columnMap.number]);

		if (existingCompetitor) {
			try {
				competitor.id = existingCompetitor.id;
				var newSeriesClass = await api.put('competitors/competitor/' + existingCompetitor.id, competitor, true);
				row.status = 'updated';
			} catch (e) {
				row.status = 'ERROR: ' + e.response.data;
			}
		}
		else {
			var newSeriesClass = await api.post('competitors/competitor', competitor, true);
			row.status = 'imported';
		}

		this.setState(state => { var rows = [...state.rows]; rows[index] = row; return { rows }; });
	}

	getAge(ssn) {
		let ssnPattern = /^(\d{2})(\d{2})(\d{2})[^\d]?(\d{3})(\d{1})$/;

		var date = new Date();
		var match = ssn.match(ssnPattern);
		if (match != null) {
			var [ssn, ssnDay, ssnMonth, ssnYear, ssnCheck, ssnCentury] = ssn.match(ssnPattern);
			var year = 2000;
			if (Number(ssnCentury) == 9) year = 1900;
			year += Number(ssnYear);

			return date.getFullYear() - year;
		}

		return null;
	}

	sortRows() {
		var sorted = [...this.state.rows].sort((a, b) => {
			var aExisting = this.getExistingCompetitor(a.values[this.state.columnMap.number]);
			var bExisting = this.getExistingCompetitor(b.values[this.state.columnMap.number]);
			var aPoints = aExisting ? (aExisting.points || 0) : -1;
			var bPoints = bExisting ? (bExisting.points || 0) : -1;

			return bPoints - aPoints;
		});

		this.setState({ rows: sorted });
	}

	groupRowsByClass(index) {
		var rows = [...this.state.rows];
		var targetRow = rows[index];
		var groupName = targetRow.values[this.state.columnMap.group];

		// Pull out all rows with the same group (excluding the clicked row)
		var sameGroup = [];
		var otherRows = [];
		for (var i = 0; i < rows.length; i++) {
			if (i !== index && rows[i].values[this.state.columnMap.group] === groupName) {
				sameGroup.push(rows[i]);
			} else {
				otherRows.push(rows[i]);
			}
		}

		// Find the clicked row's position in otherRows and insert the group members after it
		var clickedIndex = otherRows.indexOf(targetRow);
		otherRows.splice(clickedIndex + 1, 0, ...sameGroup);

		this.setState({ rows: otherRows });
	}


	parse() {
		var cleanValuePattern = /^"?(.*?)"?$/;

		var columnNames = [];

		var rows = [];

		var lines = this.state.importData.split(/\r?\n/).filter(line => line.trim() !== '');
		for (let i = 0; i < lines.length; i++) {
			let line = lines[i];

			{

				var row = {
					status: '',
					values: []
				};

				for (var value of line.split(/[,\t]/)) {
					var cleanValue = cleanValuePattern.exec(value)[1];
					if (i == 0) {
						columnNames.push(cleanValue);
					}
					else {
						row.values.push(cleanValue);
					}
				}

				if (i == 0) this.setState({ columnNames: columnNames });
				else rows.push(row);
			}
		}

		columnNames.push('**Unmapped**');

		// Auto-map classes where group name matches an existing class name exactly
		var classMap = { ...this.state.classMap };
		rows.forEach(row => {
			var groupName = row.values[this.state.columnMap.group];
			if (groupName && !classMap[groupName]) {
				var matchingClass = this.state.classes.find(c => c.name === groupName);
				if (matchingClass) {
					classMap[groupName] = matchingClass.id;
				}
			}
		});

		this.setState({ rows: rows, classMap: classMap });
	}

	render() {
		return (
			<div>
				<div className="mb-3">
					<label className="form-label">Browse CSV file:</label>
					<input type="file" accept=".csv,.txt,.tsv" onChange={this.handleFileSelect} className="form-control" />
				</div>
				<textarea value={this.state.importData} onChange={(event) => this.setState({ importData: event.target.value })} onPaste={this.handlePaste} className="form-control" rows={10} placeholder="Paste competitor data here (CSV or tab-separated)..." />

				<Button onClick={this.parse}>Parse</Button>


				<table className="table table-striped">
					<thead>
						<tr>
							<th>								
								Number:
								<select
									value={this.state.columnMap.number}
									onChange={(event) => this.setState({ columnMap: { ...this.state.columnMap, number: event.target.value } })}
									className="form-control">
									{this.state.columnNames.map((column,index) =>
										<option value={index} key={column}>{column}</option>
									)}
								</select>								
		
							</th>
							<th>
								Name:
								<select
									value={this.state.columnMap.name}
									onChange={(event) => this.setState({ columnMap: { ...this.state.columnMap, name: event.target.value } })} 
									className="form-control">
									{this.state.columnNames.map((column, index) =>
										<option value={index} key={column}>{column}</option>
								)}
								</select>
							</th>
							<th>
								SSN:
								<select
									value={this.state.columnMap.ssn}
									onChange={(event) => this.setState({ columnMap: { ...this.state.columnMap, ssn: event.target.value } })} 
									className="form-control">
									{this.state.columnNames.map((column, index) =>
										<option value={index} key={column}>{column}</option>
									)}
								</select>								
		
							</th>

							<th colSpan={2}>
								Group:
								<select
									value={this.state.columnMap.group}
									onChange={(event) => this.setState({ columnMap: { ...this.state.columnMap, group: event.target.value } })} 
									className="form-control">
									{this.state.columnNames.map((column, index) =>
										<option value={index} key={column}>{column}</option>
									)}
								</select>
							</th>
							{/*
							<th>
								Club:
								<select
									value={this.state.columnMap.club}
									onChange={(event) => this.setState({ columnMap: { ...this.state.columnMap, club: event.target.value } })}
									className="form-control">
									{this.state.columnNames.map((column, index) =>
										<option value={index} key={column}>{column}</option>
									)}
								</select>
							</th>
							*/}
							<th>
								Phone:
								<select
									value={this.state.columnMap.phone}
									onChange={(event) => this.setState({ columnMap: { ...this.state.columnMap, phone: event.target.value } })}
									className="form-control">
									{this.state.columnNames.map((column, index) =>
										<option value={index} key={column}>{column}</option>
									)}
								</select>
							</th>
							<th>
								Transponder:
								<select
									value={this.state.columnMap.transponder}
									onChange={(event) => this.setState({ columnMap: { ...this.state.columnMap, transponder: event.target.value } })}
									className="form-control">

									<option value="1337">** Generate **</option>

									{this.state.columnNames.map((column, index) =>
										<option value={index} key={column}>{column}</option>
									)}
								</select>
							</th>
							<th>
								Existing data
							</th>
							<th style={{ cursor: 'pointer' }} onClick={this.sortRows}>
								Points &#x25BC;
							</th>
							<th>
								Actions
							</th>
							<th>
								Status
							</th>
						</tr>
					</thead>
					<tbody>
						{this.state.rows.map((row, i) =>
							<tr key={i} >
								<td>
									{row.values[this.state.columnMap.number]}
								</td>
								<td>
									{row.values[this.state.columnMap.name]}															
								</td>
								<td>
									{row.values[this.state.columnMap.ssn]}

									<span> ({this.getAge(row.values[this.state.columnMap.ssn])}) </span>
								</td>
								<td>{row.values[this.state.columnMap.group]}</td>
								<td>
									<select value={this.state.classMap[row.values[this.state.columnMap.group]]} onChange={(event) => this.mapClass(row.values[this.state.columnMap.group], event.target.value)}>
										<option value="">--Map Class--</option>
										{this.state.classes.map(seriesClass =>
											<option key={seriesClass.id} value={seriesClass.id}>{seriesClass.name}</option>
										)}
										<option value="+">**Create**</option>
									</select>
								</td>
								{/*<td>{row[this.state.columnMap.club]}</td>*/}
								<td>{row.values[this.state.columnMap.phone]}</td>
								<td>
									{(this.state.columnMap.transponder == 1337) && <div>
										<input type="number" onChange={(event) => this.setTransponder(i, event.target.value)} maxLength={4} size={ 4} ></input>
										{row.transponder }
									</div>}
									{row.values[this.state.columnMap.transponder]}
								</td>
								<td>
									&nbsp;

									{this.getExistingCompetitor(row.values[this.state.columnMap.number]) &&
										<span>
											{this.getExistingCompetitor(row.values[this.state.columnMap.number]).name}
										</span>
									}

								</td>
								<td>
									{this.getExistingCompetitor(row.values[this.state.columnMap.number]) &&
										this.getExistingCompetitor(row.values[this.state.columnMap.number]).points
									}
								</td>
								<td style={{ whiteSpace: 'nowrap' }}>
									<Button className="btn btn-warning" onClick={() => this.setRemoveRow(i)}>Remove</Button>
									<Button className="btn btn-success" onClick={() => this.importRow(i)}>Import</Button>
									<Button className="btn btn-info" onClick={() => this.groupRowsByClass(i)}>Group</Button>
								</td>
								<td className={row.status === 'imported' || row.status === 'updated' ? 'text-success' : row.status ? 'text-danger' : ''}>
									{row.status}
								</td>
							</tr>
						)}
					</tbody>
				</table>


				<Button className="btn btn-primary" onClick={() => this.importAll()}>Import All</Button>

			</div>
		);
	}
}

export default function ImportCompetitorsPage() {
	const { raceid } = useParams();
	return <ImportCompetitorsComponent raceid={raceid} />;
}